// 角色页面权限门禁工具（前后端共享 page_key）
// 数据来源：登录后 /userInfo 返回的 pagePermissions + viewPermission，存于 localStorage

const SUPER_ADMIN_VP = 99

function getVP() {
  const raw = localStorage.getItem('viewPermission')
  if (raw === null || raw === '') return 1
  // 容错：历史数据可能被存成 '"99"' / 'null' / 'undefined'，parseInt 直出 NaN，
  // 而 NaN !== 99 会让超管错误地走权限矩阵分支，导致本该显示的按钮被隐藏。
  const n = parseInt(String(raw).replace(/['"]/g, ''), 10)
  return isNaN(n) ? 1 : n
}

function getMap() {
  try {
    const parsed = JSON.parse(localStorage.getItem('pagePermissions') || '{}')
    // 容错：JSON.parse('null') 得到 null，直接 m[key] 会抛异常并中断 render
    return (parsed && typeof parsed === 'object') ? parsed : {}
  } catch (e) {
    return {}
  }
}

// 超级管理员恒为 true；其余按角色页面权限矩阵判定
export function canView(key) {
  if (getVP() === SUPER_ADMIN_VP) return true
  const m = getMap()
  const p = m[key]
  return !!(p && p.view)
}

export function canAdd(key) {
  if (getVP() === SUPER_ADMIN_VP) return true
  const m = getMap()
  const p = m[key]
  return !!(p && p.add)
}

export function canEdit(key) {
  if (getVP() === SUPER_ADMIN_VP) return true
  const m = getMap()
  const p = m[key]
  return !!(p && p.edit)
}

export function canDelete(key) {
  if (getVP() === SUPER_ADMIN_VP) return true
  const m = getMap()
  const p = m[key]
  return !!(p && p.delete)
}

// 管理员层级（含超级管理员）：可进入“角色页面权限”配置页
export function isAdminTier() {
  return getVP() >= 3
}

export default { canView, canAdd, canEdit, canDelete, isAdminTier }
